import React from "react";
import schema from "./schema";
import uiSchema from "./uiSchema";
import { MuiFormBuilder } from "components";

const Form = ({ formData = {}, onChange, liveValidate }) => {
  return (
    <MuiFormBuilder
      showSubmit={false}
      schema={schema()}
      uiSchema={uiSchema()}
      formData={formData}
      onChange={onChange}
      liveValidate={liveValidate}
    />
  );
};

export default Form;
